import { List, Datagrid, TextField, SimpleList, ShowButton, DateField, EditButton } from "react-admin";
import { EmptyList } from "server/components";
import { useMediaQuery } from "@mui/material";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";

const ListAlumniEvents = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  return (
    <List exporter={false}>
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow
              style={{ marginRight: 16 }}
              fields={[{ label: "Заглавие", value: record.title }]}
            />
          )}
          secondaryText={record => (
            <div>
              <MobileListRow
                style={{ marginRight: 16 }}
                fields={[{ label: "Локация", value: record.location }]}
              />
              <DateField
                source="startsAt"
                label="Дата"
                showTime
                locales="bg-BG"
                sortable="false"
              />
            </div>
          )}
          tertiaryText={record => (
            <div style={{ display: "flex", gap: 4 }}>
              <ShowButton label="" />
              <EditButton label="" />
            </div>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="title"
            label="Заглавие"
            sortable="false"
          />

          <TextField
            source="location"
            label="Локация"
            sortable="false"
          />
          <DateField
            source="startsAt"
            label="Дата"
            showTime
            locales="bg-BG"
            sortable="false"
          />
          <ShowButton />
          <EditButton />
        </Datagrid>
      )}
    </List>
  );
};
export default ListAlumniEvents;
